// extracted by mini-css-extract-plugin
export var boxItems = "_8r-1";
export var boxItemsLg = "_8r-2";
export var button = "_8r-7";
export var buttonLg = "_8r-8";
export var filterGroupBox = "_8r-0";
export var icon = "_8r-3";
export var iconSecondary = "_8r-6";
export var iconWrapper = "_8r-4";
export var iconWrapperLg = "_8r-5";